import { ChainID, Timeframe } from '@ankr.com/chains-list';
import { ETelemetryTopOf } from 'multirpc-sdk';
import { useMemo } from 'react';

import { IUsePublicStatsProps } from 'modules/stats/hooks/usePublicStats';
import { IUseQueryProps } from 'store/queries/types';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { mapChainIdToPath } from '../utils/mapChainIdToPath';
import { chainsTimeframeToStatsTimeframeMap } from '../constants';

export interface IUsePublicStatsParams extends IUseQueryProps {
  chainId?: ChainID;
  metrics: ETelemetryTopOf[];
  timeframe: Timeframe;
  limit?: number;
}

export const usePublicStatsParams = ({
  chainId,
  limit,
  metrics,
  skipFetching: skipFetchingProp,
  timeframe,
}: IUsePublicStatsParams) => {
  const { isLoggingIn } = useAuth();

  const blockchains = useMemo(
    () => (chainId ? [mapChainIdToPath(chainId)] : undefined),
    [chainId],
  );
  const skipFetching = skipFetchingProp || isLoggingIn;

  const publicStatsParams = useMemo(
    (): IUsePublicStatsProps => ({
      blockchains,
      metrics,
      timeframe: chainsTimeframeToStatsTimeframeMap[timeframe],
      skipFetching,
      limit,
    }),
    [blockchains, metrics, skipFetching, timeframe, limit],
  );

  return { publicStatsParams };
};
